import React from 'react';
import { Star, BookMarked } from 'lucide-react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';

/**
 * FeaturedBookPanel — admin chooses which book to feature on the home page
 * hero. Pure presentation: parent owns the books list, current selection,
 * the form input value, and the save handler.
 *
 * Extracted from AdminSettings.jsx (2026-05-29).
 */
const FeaturedBookPanel = ({
  currentFeaturedBook,
  books,
  featuredBookId,
  onFeaturedBookIdChange,
  onSave,
  saving,
}) => {
  return (
    <div className="bg-white/5 rounded-xl border border-white/10 p-6" data-testid="featured-book-section">
      <div className="flex items-center mb-6">
        <Star className="h-6 w-6 text-yellow-500 mr-2" />
        <h2 className="text-xl font-bold text-white">Featured Book</h2>
      </div>

      {/* Current Featured Book Display */}
      {currentFeaturedBook && (
        <div className="bg-white/5 rounded-lg p-4 mb-6 border border-white/10">
          <p className="text-gray-400 text-sm mb-2">Currently Featured:</p>
          <div className="flex items-center space-x-3">
            <BookMarked className="h-5 w-5 text-yellow-500" />
            <div>
              <p className="text-white font-medium">{currentFeaturedBook.title}</p>
              <p className="text-gray-400 text-sm">by {currentFeaturedBook.author}</p>
            </div>
          </div>
        </div>
      )}

      {/* Book Selector */}
      <div className="space-y-4">
        <div>
          <Label className="text-white mb-2 block">Select Featured Book</Label>
          <select
            value={featuredBookId}
            onChange={(e) => onFeaturedBookIdChange(e.target.value)}
            className="w-full h-12 px-4 bg-white/5 border border-white/10 rounded-lg text-white focus:border-red-500 focus:outline-none"
            data-testid="featured-book-select"
          >
            <option value="" className="bg-gray-900">-- Select a book --</option>
            {books.map((book) => (
              <option key={book.id} value={book.id} className="bg-gray-900">
                {book.title} - {book.author}
              </option>
            ))}
          </select>
        </div>

        <Button
          onClick={onSave}
          disabled={saving || !featuredBookId}
          className="w-full bg-red-600 hover:bg-red-700 disabled:opacity-50"
          data-testid="save-featured-btn"
        >
          {saving ? 'Saving...' : 'Save Featured Book'}
        </Button>

        <p className="text-gray-500 text-sm">
          The featured book will be prominently displayed in the hero section on the home page.
        </p>
      </div>
    </div>
  );
};

export default FeaturedBookPanel;
